import { computed, type Ref } from 'vue'

import type { IIdentifiable } from '@/common/models/models'

const useColumnLayout = <T extends IIdentifiable> (columns: number, entries: Ref<Array<T>>) => {
    const indexes = computed(() => {
        const elements = Math.ceil(entries.value.length / columns)

        return Array.from({ length: elements }, (_, i) => {
            return i * columns
        })
    })

    return {
        indexes
    }
}

export {
    useColumnLayout
}
